import { lazy } from 'react';
import App from '../App';

const VoiceApply = lazy(() => import('@pages/VoiceApply'));
const AnchorApply = lazy(() => import('@pages/AnchorApply'));
const MyGuildApply = lazy(() => import('@pages/MyGuildApply'));
const FacialRecord = lazy(() => import('@pages/FacialRecord'));
const PaySucess = lazy(() => import('@pages/PaySucess'));
const PayFail = lazy(() => import('@pages/PayFail'));
const AnchorAgree = lazy(() => import('@pages/AnchorAgree'));
const VoiceAgree = lazy(() => import('@pages/VoiceAgree'));
const MyLevel = lazy(() => import('@pages/MyLevel'));
const MyAgency = lazy(() => import('@pages/MyAgency'));
const Invitation = lazy(() => import('@pages/Invitation'));
const Invited = lazy(() => import('@pages/Invited'));
const Share = lazy(() => import('@pages/Share'));
const MyManage = lazy(() => import('@pages/MyManage'));
const MyAccount = lazy(() => import('@pages/MyAccount'));
const UserHelp = lazy(() => import('@pages/UserHelp'));
const Rules = lazy(() => import('@pages/Rule'));
const MyTask = lazy(() => import('@pages/MyTask'));
const HostCenter = lazy(() => import('@pages/HostCenter'));
const NoData = lazy(() => import('@pages/Nodata'));
const Recharge = lazy(() => import('@pages/Recharge'));
const AirwallexPay = lazy(() => import('@pages/AirwallexPay'));
const MusicImport = lazy(() => import('@pages/MusicImport'));
const MusicImporting = lazy(() => import('@pages/MusicImporting'));
const BlindboxGift = lazy(() => import('@pages/BlindboxGift'));

const Index = [
  {
    path: '/',
    Component: App,
    children: [
      {
        path: '/',
        Component: () => {
          window.location.href = '/my-guild-apply';
          return null;
        },
      },
      {
        path: '/my-guild',
        Component: MyAgency,
      },
      {
        path: '/pay-sucess',
        Component: PaySucess,
      },
      {
        path: '/pay-fail',
        Component: PayFail,
      },
      {
        path: '/my-guild-apply',
        Component: MyGuildApply,
      },
      {
        path: '/anchor-apply',
        Component: AnchorApply,
      },
      {
        path: '/facial-record',
        Component: FacialRecord,
      },
      {
        path: '/voice-apply',
        Component: VoiceApply,
      },
      {
        path: '/anchor-agree',
        Component: AnchorAgree,
      },
      {
        path: '/voice-agree',
        Component: VoiceAgree,
      },
      {
        path: '/my-level',
        Component: MyLevel,
      },
      //   {
      //     path: '/my-agency',
      //     Component: MyAgency, 
      //   },
      {
        path: '/invitation',
        Component: Invitation,
      },
      {
        path: '/invited',
        Component: Invited,
      },
      {
        path: '/share-room',
        Component: Share,
      },
      {
        path: '/my-manage',
        Component: MyManage,
      },
      {
        path: '/my-account',
        Component: MyAccount,
      },
      {
        path: '/user-help',
        Component: UserHelp,
      },
      {
        path: '/platform-rule',
        Component: Rules,
      },
      {
        path: '/my-task',
        Component: MyTask,//NoData,
      },
      {
        path: '/host-center',
        Component: HostCenter//NoData,
      },
      {
        path: '/recharge',
        Component: Recharge
      },
      {
        path: '/airwallex-pay',
        Component: AirwallexPay
      },
      {
        path: '/music-import',
        Component: MusicImport
      },
      {
        path: '/music-importing',
        Component: MusicImporting
      },
      {
        path: '/blindbox-gift',
        Component: BlindboxGift
      },
      {
        path: '*',
        Component: NoData,
      },
    ],
  },
];

export default Index;
